function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import styled from "styled-components";
import { space, color } from "styled-system";
var Svg = styled("svg")({
  flex: "none"
}, space, color);
var SvgBcc = React.forwardRef(function (props, ref) {
  return React.createElement(Svg, _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "currentcolor",
    height: props.size,
    width: props.size,
    ref: ref
  }), React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z",
    fill: "inherit"
  }), React.createElement("path", {
    d: "M5.513 14.49c-.006-2.259 1.585-4.155 3.86-4.582.196-.036.251-.101.246-.291a31.23 31.23 0 010-1.522c.004-.182-.054-.291-.211-.393-.547-.356-.77-1.004-.57-1.587a1.406 1.406 0 011.416-.968c.578.027 1.106.457 1.262 1.028a1.368 1.368 0 01-.57 1.52c-.18.113-.236.228-.23.432.015.507.01 1.014.003 1.522-.002.147.02.226.194.248.332.044.657.133.965.265.115.05.178.02.255-.066a957.472 957.472 0 013.238-3.55c.112-.12.08-.204.029-.33a1.617 1.617 0 01.388-1.818c.455-.424 1.206-.544 1.75-.281.638.31.99.904.946 1.601-.059.933-.966 1.636-1.887 1.445-.187-.04-.295.006-.416.139a592.976 592.976 0 01-3.018 3.31c-.122.133-.14.204.013.336 1.653 1.442 2.103 3.614 1.161 5.593-.071.15-.056.235.06.345.275.261.541.532.806.806.104.108.203.137.359.097a1.389 1.389 0 011.345 2.307c-.416.442-1.095.57-1.622.306-.576-.288-.894-.904-.758-1.536.04-.181-.002-.285-.123-.4-.224-.211-.44-.43-.65-.655-.123-.132-.198-.134-.338-.003-1.424 1.328-3.076 1.671-4.898 1.023-1.812-.643-3-2.404-3.005-4.34",
    fill: "#FEFDFC"
  }));
});
SvgBcc.displayName = "SvgBcc";
SvgBcc.defaultProps = {
  size: 24,
  color: "#F7931C"
};
export default SvgBcc;